<template>
    <el-table :data="requireGoodsItemDtoList" style="width: 100%" border>
        <el-table-column label="供应商" prop="vendorName"></el-table-column>
        <el-table-column label="商品名称" prop="title"></el-table-column>
        <el-table-column label="合同名称" prop="contractTitle"></el-table-column>
        <el-table-column label="数量" prop="quantity"></el-table-column>
        <el-table-column label="含税价(元)" prop="price" align="right">
            <template slot-scope="rows">
                <span v-if="rows.row.price != null">{{rows.row.price.toFixed(2)}}</span>
                <span v-else>0.00</span>
            </template>
        </el-table-column>
        <el-table-column label="税率(%)" prop="taxRate" align="right">
            <template slot-scope="rows">
                <span v-if="rows.row.taxRate != null">{{rows.row.taxRate.toFixed(2)}}</span>
                <span v-else>0.00</span>
            </template>
        </el-table-column>
        <el-table-column label="未税价(元)" prop="ntxPrice" align="right">
            <template slot-scope="rows">
                <span v-if="rows.row.ntxPrice != null">{{rows.row.ntxPrice.toFixed(2)}}</span>
                <span v-else>0.00</span>
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'
    import devcReqrApi from '../../api/devcReqr'
    export default {
        name: 'swb-device-require-voucher-voucher',
        desc: '配货单新增',
        props: {
            voucherIds: {
                type: Array,
                default: null
            }
        },
        data: function () {
            return {
                requireGoodsItemDtoList: [],
            }
        },
        created: function () {
            this.getRequireGoodsItemDtoList();
        },
        methods: {
            getRequireGoodsItemDtoList: function () {
                let self = this;
                let voucherIds = self.voucherIds;
                let postData = {
                    voucherIds: voucherIds
                };
                devcReqrApi.getRequireGoodsItemDtoByVoucherIdsAndContractIdAndVoucherId(postData, function (result) {
                    if(result.type == "info") {
                        let requireGoodsItemDtoList = result.data;
                        self.requireGoodsItemDtoList = Utils.merge([], requireGoodsItemDtoList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/DeviceRequireVoucherVoucher.vue